// Contexto de sesión del Aula Virtual — separado a propósito de userContext.js
// (el login del sitio institucional no debe mezclarse con el del Aula).
import { createContext } from 'react';

const AulaUserContext = createContext();

export default AulaUserContext;

const TOKEN_KEY = 'aulaToken';
const NOMBRE_KEY = 'aulaNombre';
const ROL_KEY = 'aulaRol';

export const getAulaSession = () => ({
    token: localStorage.getItem(TOKEN_KEY),
    nombre: localStorage.getItem(NOMBRE_KEY),
    rol: localStorage.getItem(ROL_KEY)
});

export const setAulaSession = ({ token, nombre, rol }) => {
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(NOMBRE_KEY, nombre);
    localStorage.setItem(ROL_KEY, rol);
};

export const clearAulaSession = () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(NOMBRE_KEY);
    localStorage.removeItem(ROL_KEY);
};

export const aulaAuthHeaders = () => {
    const { token } = getAulaSession();
    return token ? { 'Authorization': `Bearer ${token}` } : {};
};
